<template>
  <div>
    <v-card
        height="100px"
        elevation="3"
        class="px-2 my-3 mx-0"
        rounded
    >
             <span v-for="item in items" no-gutters>
               <v-row no-gutters v-if="item.divider">
                  <v-divider></v-divider>
               </v-row>
               <v-row no-gutters :class="{'font-weight-bold': item.bold}">
                 <v-col>{{ item.name }}:</v-col>
                 <v-col>{{ item.value }}</v-col>
               </v-row>
             </span>
<!--      <v-treeview-->
<!--          id="tree-view"-->
<!--          open-all-->
<!--          dense-->
<!--          :items="items"-->
<!--          class="treeview"-->
<!--      >-->
<!--&lt;!&ndash;        <template v-slot:label="{ item }">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="treeview-item">{{ item.name }}</div>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--        <template v-slot:append="{ item, open }">-->
<!--          {{ item.value }}-->
<!--        </template>-->
<!--      </v-treeview>-->
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'MPNResearchDetailCell',
  props: ['items'],

  components: {},

  computed: {},

  created() {
    // window.addEventListener("resize", this.onResize)
  },
  destroyed() {
    // window.removeEventListener("resize", this.onResize);
  },

  methods: {},

  async mounted() {
    // window.addEventListener("resize", this.onResize)
  },

  data() {
    return {}
  },

}
</script>

<style scoped lang="scss">
#tree-view div.v-treeview-node__root {
  display: flex;
  align-items: center;
  min-height: 20px !important;
  }
.v-treeview-node__content, .v-treeview-node__label {
  flex-shrink: 1;
  word-break: break-all;
}
.v-treeview-node__root {
  display: flex;
  align-items: center;
  min-height: 20px;
}
</style>
